// components/confirmCoverLayoutModal.jsx
// Модалка подтверждения смены макета обложки. Промис → true (Продолжить) / false.
//   const ok = await confirmCoverLayoutModal();
//   if (!ok) return;
import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

function Dialog({ onResult }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));
    const onKey = (e) => { if (e.key === "Escape") onResult(false); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onResult]);

  return (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) onResult(false); }}
      style={{
        position: "fixed", inset: 0, zIndex: 100000,
        background: "rgba(0,0,0,0.55)", display: "flex",
        alignItems: "center", justifyContent: "center", padding: 16,
        opacity: shown ? 1 : 0, transition: "opacity 0.15s",
      }}
    >
      <div style={{
        background: "#fff", borderRadius: 16, maxWidth: 380, width: "100%",
        padding: 22, boxShadow: "0 12px 48px rgba(0,0,0,0.25)",
        transform: shown ? "scale(1)" : "scale(0.96)", transition: "transform 0.15s",
      }}>
        <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 8, color: "#1a1a1a" }}>
          Смена макета обложки
        </div>
        <div style={{ fontSize: 14, lineHeight: 1.5, color: "#444", marginBottom: 20 }}>
          Вы меняете макет обложки. Загруженные в него фото будут удалены. Продолжить?
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={() => onResult(false)} style={{
            padding: "9px 18px", borderRadius: 10, border: "none",
            background: "#eee", color: "#333", fontSize: 14, fontWeight: 600, cursor: "pointer",
          }}>Отмена</button>
          <button onClick={() => onResult(true)} style={{
            padding: "9px 18px", borderRadius: 10, border: "none",
            background: "#834A90", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer",
          }}>Продолжить</button>
        </div>
      </div>
    </div>
  );
}

export function confirmCoverLayoutModal() {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);
    const root = createRoot(host);
    const finish = (v) => { root.unmount(); host.remove(); resolve(v); };
    root.render(<Dialog onResult={finish} />);
  });
}